import { transformVideo } from '@/helpers/transforms'
import type { HeroVideoBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import HomeHero from '../template-blocks/HomeHero'

export const HeroVideoConverter: JSXConverter<SerializedBlockNode<HeroVideoBlock>> = ({ node }) => {
	const { title, backgroundVideo, overlayVideo } = node.fields

	const backgroundVideoData = transformVideo(backgroundVideo)
	const overlayVideoData = transformVideo(overlayVideo)

	return (
		<HomeHero title={title} backgroundVideo={backgroundVideoData} overlayVideo={overlayVideoData} />
	)
}
